
import { Award, Bot, CreditCard, Handshake, LayoutGrid, Smartphone, type LucideIcon } from "lucide-react";
import { useI18n } from "@/i18n/LanguageContext";
import { Reveal, Stagger, StaggerItem } from "@/components/motion";

const ICONS: LucideIcon[] = [LayoutGrid, Bot, Award, CreditCard, Handshake, Smartphone];

export const WhyUs = () => {
  const { t } = useI18n();

  return (
    <section id="why-us" className="app-section scroll-mt-20">
      <div className="app-container">
        <Reveal className="mx-auto max-w-3xl text-center">
          <span className="section-kicker justify-center">{t.whyUs.kicker}</span>
          <h2 className="section-title">{t.whyUs.title}</h2>
          <p className="section-copy mx-auto">{t.whyUs.copy}</p>
        </Reveal>

        <Stagger className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {t.whyUs.items.map((item, index) => {
            const Icon = ICONS[index % ICONS.length];
            return (
              <StaggerItem key={item.title} className="h-full">
                <article className="app-card group flex h-full flex-col p-6">
                  <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-lg border border-primary/30 bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                    <Icon className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <h3 className="font-display text-lg font-bold leading-snug text-foreground">{item.title}</h3>
                  <p className="mt-2 text-sm leading-6 text-muted-foreground">{item.text}</p>
                </article>
              </StaggerItem>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
};
